var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input),expression:"input"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.input)},on:{"blur":function($event){return _vm.store()},"input":function($event){if($event.target.composing)return;_vm.input=$event.target.value}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }